(() => {
  if (window.__powlifeMotionInitialized) return;
  window.__powlifeMotionInitialized = true;

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const observer = reduceMotion
    ? null
    : new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          });
        },
        { threshold: 0.18, rootMargin: '0px 0px -8% 0px' }
      );

  const initializeMotion = (scope) => {
    const sections = [];

    if (scope.matches && scope.matches('[data-powlife-motion]')) sections.push(scope);
    sections.push(...scope.querySelectorAll('[data-powlife-motion]'));

    sections.forEach((section) => {
      if (section.dataset.powlifeMotionReady === 'true') return;
      section.dataset.powlifeMotionReady = 'true';
      section.classList.add('powlife-motion-ready');

      if (reduceMotion) {
        section.classList.add('is-visible');
      } else {
        requestAnimationFrame(() => observer.observe(section));
      }
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeMotion(document), { once: true });
  } else {
    initializeMotion(document);
  }

  document.addEventListener('shopify:section:load', (event) => initializeMotion(event.target));
})();
